import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccountingComponent} from './accounting.component';
import {PayoutsComponent} from './payouts/payouts.component';

    const routes: Routes = [
    {
        path: '', component: AccountingComponent,
        children: [
            {path: 'accounting/payouts', component: PayoutsComponent}
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/accounting/accounting.routing.ts